import letsGoBtn from '../../shared/assets/images/lets-go-btn.svg';
import letsRoadBtn from '../../shared/assets/images/lets-road.svg';
import ship1 from '../../shared/assets/images/ship-1.svg';
import ship2 from '../../shared/assets/images/ship-2.svg';
import ship3 from '../../shared/assets/images/ship-3.svg';
import cls from './GameOnb.module.scss';

export type contentType = {
  head: string[];
  desc: string[];
  characteristic: string[];
  page2Text: string[];
  buttonImg: any;
  shipImg: any;
  cls: any;
};
export const contentGameOnb: contentType[] = [
  {
    head: ['ледокол', 'ЕРМАК'],
    desc: ['Первый в мире ледокол арктического класса!', 'Спущен на воду в 1898 году.'],
    characteristic: [
      'Длина — 98 метров',
      'Ширина — 22 метра',
      'Скорость — 14 узлов',
      'Мощность — 12 000 лошадиных сил',
    ],
    page2Text: [
      'Ты доставляешь груз на историческом ледоколе.',
      'Его мощность ограничена, поэтому проходить можно только по мелким льдинам.',
      'Аккуратно выбирай путь, чтобы не застрять и добраться до полярников. Они очень ждут!',
    ],
    buttonImg: letsGoBtn,
    shipImg: ship1,
    cls: cls.GameOnb1,
  },
  {
    head: ['Атомный ледокол', 'Ямал'],
    desc: ['Это седьмой ледокол, достигший Северного полюса!', 'Спущен на воду в 1989 году.'],
    characteristic: [
      'Длина — 148 метров',
      'Ширина — 30 метров',
      'Скорость — 21 узел',
      'Мощность — 75 000 лошадиных сил',
    ],
    page2Text: [
      'Ты дошёл до более суровых льдов.',
      'Новый ледокол может прорубать крупные льдины, но самый плотный лёд ему всё ещё не подвластен. Осторожнее!',
      'Впереди вторая полярная станция.',
    ],
    buttonImg: letsRoadBtn,
    shipImg: ship2,
    cls: cls.GameOnb2,
  },
  {
    head: ['Атомный ледокол', 'Урал'],
    desc: ['Это самый мощный ледокол!', 'Спущен на воду в 2019 году.'],
    characteristic: [
      'Длина — 173 метра',
      'Ширина — 34 метра',
      'Скорость — 22 узла',
      'Мощность — 81 500 лошадиных сил',
    ],
    page2Text: [
      'Ты добрался до самых суровых глубин Арктики!',
      'Но теперь тебе под силу любой лёд! Не забывай про другие препятствия на пути к финальной полярной станции.',
    ],
    buttonImg: letsGoBtn,
    shipImg: ship3,
    cls: cls.GameOnb3,
  },
];
